import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Modal from '../Modal/Modal';
import ImageFigure from '../UI/Image/ImageFigure';

const CvvTooltip = ({ tooltip, cvvInfo, className }) => {
  const [showModal, setShowModal] = useState(false);

  function openModal() {
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
  }

  const cvvContent = useMemo(function () {
    return ReactHtmlParser(cvvInfo?.description || '')
  }, [cvvInfo?.description])

  return (
    <>
      <div
        role="button"
        aria-label={tooltip}
        className={`info-icon ${className}`}
        onClick={() => {
          openModal();
        }}
        /* eslint-disable-next-line @typescript-eslint/no-empty-function */
        onKeyDown={() => {}}
        tabIndex="0"
      >
        <span className="info-icon__question">?</span>
      </div>

      {showModal ? (
        <Modal closeModalHandler={closeModal} closeBtn>
          <div className="popin">
            {cvvInfo.mainTitle ? <div className="popin__title">{cvvInfo.mainTitle}</div> : null}
            <div className="popin__main">
              <div className="popin__main__left">
                <p className="popin__main__left__subtitle">{cvvInfo.additionalTitle}</p>
                <div className="popin__main__left__description">
                  {cvvContent}
                </div>
              </div>
              <div className="popin__main__right">
                <ImageFigure src={cvvInfo.img} alt={cvvInfo.imgAlt} title={cvvInfo.imgTitle} />
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default CvvTooltip;

CvvTooltip.propTypes = {
  tooltip: PropTypes.string.isRequired,
  cvvInfo: PropTypes.shape({
    img: PropTypes.string,
    imgAlt: PropTypes.string,
    imgTitle: PropTypes.string,
    mainTitle: PropTypes.string,
    additionalTitle: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
};
